import { BooleanField, FieldTypes } from '@hb/shared'
import { forwardRef } from 'react'
import { InputElement, InputProps } from '../../../../types/fields'
import { MenuDropdownInput } from '../Select/MenuDropdownInput'

const BooleanDropdown: InputElement<BooleanField> = forwardRef<
  { focus: () => void },
  InputProps<BooleanField>
>((props, ref) => {
  const { field } = props
  const { yesText = 'Yes', noText = 'No', ...passedField } = field
  return (
    <MenuDropdownInput
      ref={ref}
      {...props}
      field={{
        ...passedField,
        type: FieldTypes.DROPDOWN,
        options: [
          { id: 'Yes', text: yesText },
          { id: 'No', text: noText },
        ],
      }}
    />
  )
})

export default BooleanDropdown
